import { DocumentLabel } from "../interfaces/documentIndexLabel";
import { OrderLabel } from "../interfaces/label";

export interface DocLabelUpdateAction {
    type: "remove" | "add";
    labelName: string;
}

export interface GlobalLabelUpdateAction {
    type: "create" | "rename" | "delete";
    data: OrderLabel | { oldLabelName: string; newLabelName: string } | string;
}

export const updateDocLabels = (
    allDocLabels: Record<string, DocumentLabel>,
    payload: { docId: string; actions: Array<DocLabelUpdateAction> },
) => {
    try {
        console.log("Updating document labels with actions:", payload.actions);
        payload.actions.forEach((action) => {
            if (!action.labelName || action.labelName === undefined) {
                throw new Error(
                    "Label name is required for DocLabelUpdateAction",
                );
            }

            if (
                action.type === "remove" &&
                Object.keys(allDocLabels).includes(action.labelName)
            ) {
                // Remove the document from specific label docIds list
                allDocLabels[action.labelName].docIds = allDocLabels[
                    action.labelName
                ].docIds.filter((d) => d !== payload.docId);
            } else if (
                action.type === "add" &&
                Object.keys(allDocLabels).includes(action.labelName)
            ) {
                // Add document to specific label docIds list
                allDocLabels[action.labelName].docIds.push(payload.docId);
            }
        });
    } catch (error) {
        console.error("Error updating document labels:", error);
    }

    return allDocLabels;
};

export const updateGlobalLabels = (
    allDocLabels: Record<string, DocumentLabel>,
    actions: Array<GlobalLabelUpdateAction>,
) => {
    console.log("Updating global labels with actions:", actions);

    try {
        actions.forEach((action) => {
            if (!action.data) {
                throw new Error("Data is required for GlobalLabelUpdateAction");
            }

            if (action.type === "create") {
                // Create a new label element
                const createAction: OrderLabel = action.data as OrderLabel;
                allDocLabels[createAction.name] = {
                    color: createAction.color,
                    docIds: [],
                };
            } else if (action.type === "rename") {
                // Rename existing label
                const renameAction = action.data as {
                    oldLabelName: string;
                    newLabelName: string;
                };
                if (
                    Object.keys(allDocLabels).includes(
                        renameAction.oldLabelName,
                    )
                ) {
                    allDocLabels[renameAction.newLabelName] =
                        allDocLabels[renameAction.oldLabelName];
                    delete allDocLabels[renameAction.oldLabelName];
                }
            } else if (action.type === "delete") {
                // Delete existing label
                const toBeDeletedLabel = action.data as string;
                if (Object.keys(allDocLabels).includes(toBeDeletedLabel)) {
                    delete allDocLabels[toBeDeletedLabel];
                }
            }
        });
    } catch (error) {
        console.error("Error updating global labels:", error);
    }

    return allDocLabels;
};
